module.exports = __webpack_public_path__ + "6312475b0732cec0e48582b90496bf8b.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/futurico/futurico.png
// module id = 299
// module chunks = 0